import { render, staticRenderFns } from "./PortalRfxRelatedFiles.vue?vue&type=template&id=031520b1&scoped=true"
import script from "./PortalRfxRelatedFiles.vue?vue&type=script&lang=js"
export * from "./PortalRfxRelatedFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031520b1",
  null
  
)

export default component.exports